import React from 'react'

export const DotButton = (props) => {
  // eslint-disable-next-line react/prop-types
  const { selected, index, selectedIndex, onClick } = props
  const isNearDot = index + 1 === selectedIndex || index - 1 === selectedIndex
  const isSecondNearDot = index + 2 === selectedIndex || index - 2 === selectedIndex
  return (
    <button
      onClick={onClick}
      type="button"
      className={`embla__dot${selected ?
        ' embla__dot--selected' : ''}${isNearDot ? ' embla__dot--selected-near' : ''}
          ${isSecondNearDot ? ' embla__dot--selected-second-near' : ''}`}

    />
  )
}
